import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/' || location.pathname === '';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenu(false);

    // Manejar scroll a secciones cuando hay hash en la URL
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  const handleHashClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();

    if (isHome) {
      // Si estamos en home, solo hacer scroll
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Si estamos en otra página, navegar a home con el hash
      navigate('/' + hash);
    }
  };

  const showTransparent = isHome && !scrolled;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${showTransparent ? 'bg-transparent' : 'bg-white/95 backdrop-blur-md shadow-lg'
      }`}>
      <div className="w-full px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-12">
            <Link to="/" className="flex items-center space-x-2 cursor-pointer">
              <div className="w-9 h-9 bg-emerald-500 rounded-lg flex items-center justify-center">
                <i className="ri-eye-line text-white text-lg"></i>
              </div>
              <div>
                <h1 className={`text-lg font-bold leading-none ${showTransparent ? 'text-white' : 'text-gray-900'}`}>
                  La Millefera Tech
                </h1>
                <span className={`text-[10px] font-medium tracking-widest uppercase ${showTransparent ? 'text-emerald-300' : 'text-emerald-600'}`}>
                  Anamnesy Soft
                </span>
              </div>
            </Link>
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${showTransparent ? 'text-white/90 hover:text-white' : 'text-gray-700 hover:text-emerald-600'} ${location.pathname === '/' ? '!text-emerald-500' : ''}`}>Inicio</Link>
              <a href="#producto" onClick={(e) => handleHashClick(e, '#producto')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${showTransparent ? 'text-white/90 hover:text-white' : 'text-gray-700 hover:text-emerald-600'}`}>Producto</a>
              <a href="#funcionalidades" onClick={(e) => handleHashClick(e, '#funcionalidades')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${showTransparent ? 'text-white/90 hover:text-white' : 'text-gray-700 hover:text-emerald-600'}`}>Funcionalidades</a>
              <a href="#beneficios" onClick={(e) => handleHashClick(e, '#beneficios')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${showTransparent ? 'text-white/90 hover:text-white' : 'text-gray-700 hover:text-emerald-600'}`}>Beneficios</a>
              <Link to="/precios" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${showTransparent ? 'text-white/90 hover:text-white' : 'text-gray-700 hover:text-emerald-600'} ${location.pathname === '/precios' ? '!text-emerald-500' : ''}`}>Precios</Link>
              <Link to="/sobre-nosotros" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${showTransparent ? 'text-white/90 hover:text-white' : 'text-gray-700 hover:text-emerald-600'} ${location.pathname === '/sobre-nosotros' ? '!text-emerald-500' : ''}`}>Nosotros</Link>
            </div>
          </div>
          <div className="hidden lg:flex items-center space-x-4">
            <a href="#contacto" onClick={(e) => handleHashClick(e, '#contacto')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${showTransparent ? 'text-white/90 hover:text-white' : 'text-gray-700 hover:text-emerald-600'}`}>Contacto</a>
            <a href="https://anamnesysoft.com/" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 bg-emerald-500 text-white text-sm font-semibold rounded-lg hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer">
              Registrarse / Ingresar
            </a>
          </div>
          <button
            onClick={() => setMobileMenu(!mobileMenu)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenu ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${showTransparent ? 'text-white' : 'text-gray-900'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenu && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-xl">
          <div className="px-6 py-4 space-y-3">
            <Link to="/" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Inicio</Link>
            <a href="#producto" onClick={(e) => handleHashClick(e, '#producto')} className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Producto</a>
            <a href="#funcionalidades" onClick={(e) => handleHashClick(e, '#funcionalidades')} className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Funcionalidades</a>
            <a href="#beneficios" onClick={(e) => handleHashClick(e, '#beneficios')} className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Beneficios</a>
            <Link to="/precios" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Precios</Link>
            <Link to="/sobre-nosotros" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Nosotros</Link>
            <a href="#contacto" onClick={(e) => handleHashClick(e, '#contacto')} className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Contacto</a>
            <a href="https://anamnesysoft.com/" target="_blank" rel="noopener noreferrer" className="block w-full text-center px-6 py-2.5 bg-emerald-500 text-white text-sm font-semibold rounded-lg cursor-pointer">Registrarse / Ingresar</a>
          </div>
        </div>
      )}
    </nav>
  );
}
